import React from "react";

export default function Promise() {
    return (
        <section
            id="promise"
            className="bt-section"
            data-testid="section-promise"
            style={{ borderTop: "1px solid var(--bt-rule)" }}
        >
            <div className="bt-shell">
                <div
                    className="bt-promise-grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        gap: 32,
                    }}
                >
                    {/* Hanging marginalia */}
                    <aside style={{ paddingTop: 14 }}>
                        <p className="signal" style={{ marginBottom: 14 }}>
                            № 01
                        </p>
                        <p className="marginalia" style={{ margin: 0, color: "var(--bt-mute)" }}>
                            The premise
                        </p>
                    </aside>

                    {/* Editorial column */}
                    <div className="bt-read">
                        <h2
                            className="t-display"
                            style={{ margin: 0, marginBottom: 36 }}
                        >
                            No hype. No upsells. No &ldquo;million-dollar trade alerts.&rdquo;
                        </h2>

                        <p className="t-lede" style={{ margin: 0, marginBottom: 24 }}>
                            Most financial media is selling you something. A trade. A
                            subscription. A book. A panic. Brass Tacks Brief is a free
                            monthly read built on a different premise: that grown adults
                            can handle the truth about their money in plain English, and
                            that the most valuable financial intelligence is usually the
                            boring kind nobody else has the patience to write down.
                        </p>

                        <p className="t-body" style={{ margin: 0, marginBottom: 32 }}>
                            We track what matters for your retirement. Inflation. The
                            dollar. Federal debt. Tax law. Hard assets. Policy moves out
                            of Washington that change what a dollar of your savings is
                            worth. We write it once a month, in fewer than 1,500 words,
                            and we send it to your inbox.
                        </p>

                        <p
                            className="f-display-italic"
                            style={{
                                margin: 0,
                                fontSize: "clamp(20px, 2vw, 26px)",
                                color: "var(--bt-ink)",
                                lineHeight: 1.4,
                                fontVariationSettings: '"opsz" 60, "SOFT" 0',
                                letterSpacing: "-0.012em",
                            }}
                        >
                            That&rsquo;s it. That&rsquo;s the whole thing.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
